import { create } from "apisauce"


const Baseurl = create({
    baseURL: 'https://opddemo.kmaschool.com/api/pannel'
  })
  export default Baseurl;
